import React, {useState} from "react";
import PropTypes from "prop-types";
// import "../../css/common.css";
import Select from 'react-select';
import { validateInput } from "../../library/utilities/Validator";

const ReactSelect = ({
  label,
  labelStyle,
  inputClass,
  labelClass,
  disabled,
  value,
  style,
  name,
  options,
  required,
  handleChange:change,
  placeholder,
  getOptionLabel,
  getOptionValue,
  defaultValue,
  isMulti,
  Error,
  validators,
  getError
}) => { 
  
  const [error, setError] = useState(false);
  const handleChange = (val, labelName) => {
    if (validateInput(validators, val))
      setError(validateInput(validators, val));
    else if (!validateInput(validators, val) && value !== "") {
      setError(false);
    } else {
      setError(false);
    }
    change(val, labelName);
    getError &&
      getError(
        validateInput(validators, val) ? validateInput(validators, val) : false
      );
  };
  return (
    <>
      <div className={labelClass}>
        <label style={labelStyle ? labelStyle : {}}>
          {label}
          {required ? <b> *</b> : ""}
        </label>
      </div>
      <div className={inputClass ? inputClass : "col-md-4"}>
        <div>
            <Select 
                getOptionLabel={getOptionLabel}
                getOptionValue={getOptionValue}
                placeholder={placeholder}
                value={value}
                defaultValue={defaultValue}
                name={name}
                isDisabled={disabled}
                onChange={handleChange}
                options={options} 
                isMulti={isMulti}
            />
        </div>
        {(error || Error && Error[name]) && <span className="text-danger errormsg">{error.message|| Error[name]}</span>}
    
      </div>

    </>
  );
};
ReactSelect.propTypes = {
  label: PropTypes.string,
  onchange: PropTypes.func,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
  placeholder: PropTypes.string,
};

ReactSelect.defaultProps = {
  placeholder: "",
  label: "",
  labelClass: "col-md-4",
  inputClass: "col-md-4",
};

export default ReactSelect;
